class AnnouncementBar extends HTMLElement {
    constructor() {
        super();

        this.announcementsMarqueeAnimationClassName = 'tw-animate-marquee';
        this.marqueeSpeed = 2.5;
        this.marqueeObject = '.marquee'
    }

    connectedCallback() {
        this.announcements = this.querySelectorAll('li');

        if (this.announcements.length === 0) {
            return;
        }

        this.announcementsList = this.querySelector('ul');
        this.animateAnnouncements(this.marqueeObject, this.marqueeSpeed);
    }


    animateAnnouncements(selector, speed) {
        const parentSelector    = document.querySelector(selector);
        const width             = parentSelector.offsetWidth;
        const clone             = parentSelector.innerHTML;
        const firstElement      = parentSelector.children[0];
        const firstElementWidth = firstElement.getBoundingClientRect().width;
        let   i                 = 0;
        let   counter           = 0;
        const times             = width / firstElementWidth;
        do {
            counter = counter + 1;
            parentSelector.insertAdjacentHTML("beforeend", clone);
        } while (counter < times);

        setInterval(function () {
            firstElement.style.marginLeft = `-${i}px`;
            if (i > firstElement.clientWidth) {
                i = 0;
            }
            i = i + speed / 10;
        }, 0);
    }

}
customElements.define('bt-announcement-bar', AnnouncementBar);